import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { Wrapper,TextField, TextArea, SelectField ,FormTitle,ImageUpload, DateTimeTextField} from "../controllers/controllers";
import * as Yup from "yup";
import styles from "../controllers/controllers.module.css";
import { EditButton, Submit } from "../../../../components/button/buttons";
import IMAGES from "../../../../assets/images/images";
import {connect} from "react-redux";
import {setIncidentPreviewMode} from "../../../../redux/actions/incidentManagement/raiseIncident.action";
import { ADD_TICKET_ACTION, FromLabel, incidentTimeInterval, incidentTimePlaceHolder, MAX_FILES, MY_INCIDENT_TABS, Priority_Options} from "../../../../utils/constants/incidentConstants";
import {convertToTimestampObject, getLabelFromValue} from "../../../../utils/arrayUtils"
import {SubmitIncident} from "../../../../redux/actions/incidentManagement/raiseIncident.action";
import {openAlertPopup} from "../../../../redux/actions/Alert/alert.action";
import {getIncidentList} from "../../../../redux/actions/incidentManagement/incidentList.action";
import { incidentDownloadFiles } from "../../../../redux/actions/fileAttachment/fileAttachment.actions";
import { setIncidentActiveTab } from "../../../../redux/actions/incidentManagement/incidentTab.action";
import moment from 'moment';
import { showErrorPopup } from "../../../../redux/actions/customErrorPopup/customerrorpopup.action";
import { useNavigate } from "react-router-dom";
import { getModuleNotification } from "../../../../redux/actions/notification/getModuleNotification.action";
import { DateTimePicker } from "../../../../components/dateTimePicker/DateTimePicker";
import { useDateLimits } from "../../../../hooks/useDateLimits";
import MultipleEmailInput from "../../../../components/multipleEmailInput/MultipleEmailInput";

const SigtranSignallingIssueMultipleForm = ({ service_type, issue_type, failure_type,parentFormData,actionType,incidentData, ...props }) => {
    const [isSubmit, setIsSubmit] = useState(false);
    const navigate = useNavigate();
    const { dateLimits, handleCalendarOpen,getTimeProps} = useDateLimits(true);
    const onFileDownload=(file)=>{
        props.incidentDownloadFile(file.originalFileName,file.uniqueFileName,file.messageId,file.attachmentId,file.graphInternetMessageId)
        .then((result)=>{
            if(!result.status){
                alert("Error while downloding file!");
            }
        }).catch((error)=>{
        alert("Something went wrong!")
        })
    }
    let initialValues = {};
    if(actionType===ADD_TICKET_ACTION.INCIDENT_DETAILS){
        initialValues = {
            issue_summary:incidentData?.issueDetails?.title,
            priority:incidentData?.issueDetails?.priority,
            problem_statement:incidentData?.issueDetails?.problemStatement,
            home_network:incidentData?.issueDetails?.homeNetworkPLMN,
            visited_network: incidentData?.issueDetails?.visitedNetworkPLMN,
            calling_global_titles:incidentData?.issueDetails?.callingGlobalTitles,
            called_global_titles:incidentData?.issueDetails?.calledGlobalTitles,
            opc_detail: incidentData?.issueDetails?.originatingPointCodeDetails,
            dpc_detail: incidentData?.issueDetails?.destinationPointCodeDetails,      
            imsi_source: incidentData?.issueDetails?.IMSIDetails,
            msi_MSISDN: incidentData?.issueDetails?.mobileSubscriberIdentity,
            error_received: incidentData?.issueDetails?.errorReceived,
            date_time: incidentData?.issueDetails?.issueStartedDateTime,
            source_ip:incidentData?.issueDetails?.sourceIPDetails,
            destination_ip: incidentData?.issueDetails?.destinationIPDetails,
            traces_routes: incidentData?.issueDetails?.traceRoutes,
            trace_text: incidentData?.issueDetails?.tracesTextOrIMSI,
            trace_file: incidentData?.issueDetails?.tracesTextOrIMSIAttachment,
            additionalEmails:incidentData?.issueDetails?.additionalEmails, 
            additional_information: incidentData?.issueDetails?.additionalInformation,
        };
    }else{
        initialValues = {
            issue_summary:"",
            priority:"",
            problem_statement:"",
            home_network:"",
            visited_network: "",
            calling_global_titles:"",
            called_global_titles:"",
            opc_detail: "",
            dpc_detail: "",      
            imsi_source: "",
            msi_MSISDN:'',
            error_received: "",
            date_time: "",
            source_ip:"",
            destination_ip: "",
            additionalEmails:[],
            traces_routes: "",
            trace_text: "",
            trace_file:[],
            additional_information:"",
        };
    } 
// oneitsm_api_integration: Validation interim MAX_FILES: 15 file and OneITSM MAX_FILES:1 file
    const validationSchema = Yup.object().shape({
        issue_summary: Yup.string().max(100, "Issue summary must be at most 100 characters").required("Required"),
        priority: Yup.string(),
        problem_statement:Yup.string().max(1000, "Problem statement must be at most 1000 characters").required("Required"),
        home_network:Yup.string().required("Required"), //.matches(/^[a-zA-Z0-9]*$/,'Only alphanumeric characters are allowed.')
        visited_network:Yup.string().required("Required"), //.matches(/^[a-zA-Z0-9]*$/,'Only alphanumeric characters are allowed.')
        calling_global_titles:Yup.string().required("Required"),
        called_global_titles:Yup.string().required("Required"),
        opc_detail:Yup.string(),
        dpc_detail:Yup.string(),      
        msi_MSISDN:Yup.string().required("Required"),//.matches(/^[\d+-]*$/,'Invalid format. Only digit, plus(+) and hyphen(-) allowed.')
         imsi_source:Yup.string().required("Required"),
        error_received:Yup.string(),
        additionalEmails: Yup.array().of(Yup.string().trim().email("Please enter a valid email address.")),
        date_time:Yup.string().required("Required")
        .test({
            name: 'Time',
            message: "Future Date or Time not allowed.",
            test: function(value) {
                const currentDateTime = moment().utc().format('YYYY-MM-DDTHH:mm')
              if (value>currentDateTime) {
                return false;
              }
              return true;
            }
          }),
        source_ip:Yup.string(),
        destination_ip:Yup.string(),
        traces_routes:Yup.string(),
        trace_text:Yup.string().max(1000, "Traces must be at most 1000 characters").test(
            {
                name:'Required',
                message:'At least one of the fields Traces description or supporting attachments required',
                test:function(value){
                    let file= this.resolve(Yup.ref('trace_file'));
                    let text=value;
                    return text?.trim().length > 0 || file.length > 0
                }
            }
        ),
        trace_file:Yup.array().max(MAX_FILES).test(
            {
                name:'Required',
                message:'At least one of the fields Traces description or supporting attachments required',
                test:function(value){
                    let text= this.resolve(Yup.ref('trace_text'));
                    let file=value;
                    return text?.trim().length > 0 || file.length > 0
                }
            }
        ),
        additional_information:Yup.string().max(1000, "Text must be at most 1000 characters")
    })

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
                if(props.isIncidentPreviewModeOn){
                   setIsSubmit(true);                                   
                let obj = {
                    incidentServiceType: parentFormData.service_type,
                    incidentFaultType: parentFormData.issue_type,
                    failureRelatedType: parentFormData.failure_type,
                    impactedSubscriber: parentFormData.impacted_subscriber,
                    uniqueCustomerRefId:props.myRights?.customerUserMetaInfo?.uniqueCustomerRefId,
                    issueDetails: {
                        title: values.issue_summary,
                        problemStatement: values.problem_statement,
                        priority: values.priority,
                        homeNetworkPLMN: values.home_network,
                        visitedNetworkPLMN: values.visited_network,
                        callingGlobalTitles: values.calling_global_titles,
                        calledGlobalTitles: values.called_global_titles,
                        originatingPointCodeDetails: values.opc_detail,
                        destinationPointCodeDetails: values.dpc_detail,
                        IMSIDetails: values.imsi_source,
                        mobileSubscriberIdentity:values.msi_MSISDN,
                        errorReceived: values.error_received,
                        issueStartedDateTime: values.date_time,
                        issueStartedTimeStampUNIX:convertToTimestampObject(values?.date_time),
                        tracesTextOrIMSI: values.trace_text,
                        sourceIPDetails: values.source_ip,
                        additionalEmails:values.additionalEmails,
                        destinationIPDetails: values.destination_ip,
                        traceRoutes: values.traces_routes,
                        tracesTextOrIMSIAttachment: values.trace_file, 
                        additionalInformation: values.additional_information
                    }
                  };  
                
                props.addIncident(obj).then((result) => {        
                  if (result.status) {
                    props.openAlertPopup({
                      message: `A new incident with ID: ${result?.res?.data?.ticketIdServiceDesk} has been created.`,
                      image: IMAGES.success
                    });
                    if(props.incidentActiveTab===MY_INCIDENT_TABS.MY_SERVICE_REQUEST){
                        props.setIncidentActiveTab(MY_INCIDENT_TABS.MY_INCIDENTS);
                        navigate('/incident-management/incidents');
                    }           
                    setIsSubmit(false);
                    props.closeForm();
                    resetForm();
                    props.getIncidentList();
                    props.getModuleNotification();
                  } else {
                    if(result.code === 500){
                        const errormsg = <div>Service temporarily unavailable. Please try again later.<div style={{marginTop:'10px'}}>If the issue persists while using the portal, you may report it via email at cscvcs@vodafone.com with relevant details. </div></div>
                        props.showErrorPopup({errorHeader:"Service Unavailable"},{errorMessage:errormsg},{isnote:true });
                        setIsSubmit(false);
                        }else{
                    let error_msg = result?.error;
                    props.openAlertPopup({
                      message: error_msg,
                      image: IMAGES.error,
                      isFormOpen:true
                    }); } 
                     setIsSubmit(false);
                  //   props.closeForm();
                  }
                })
                .catch((error) => {
                  props.openAlertPopup({
                    message: "An error occurred while processing your request. Please try again later.",
                    image: IMAGES.error,
                    isFormOpen:true
                  }); 
                  setIsSubmit(false);
             //     props.closeForm();
                });
            }else{
                props.setIncidentPreviewMode(true);
            }   
            }}
        >
            {({ isValid, dirty, setFieldValue, values, handleChange, handleSubmit, handleBlur, resetForm }) => {
                const timeProps = getTimeProps(values.date_time);
                return(
                <>
                    <FormTitle
                            title={actionType===ADD_TICKET_ACTION.INCIDENT_DETAILS?null:(props.isIncidentPreviewModeOn?"Please Check The Details":"Please Provide The Details")}
                    />
                    <Form 
                        id="diameter_signalling_issue_form"
                        className={styles.form}
                        onSubmit={handleSubmit}
                    >
                        <TextField
                            label="Title"
                            type="text"
                            name="issue_summary"
                            isMandatory={true}
                            placeholder="Enter here"
                            isExpandedField={true}
                            showTooltip={true}
                            tooltipText={"Title"}
                            textLimit={`${values?.issue_summary?.length}/100 characters`}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                        <SelectField
                            label={"Priority"}
                            name="priority"
                            placeholder="Choose priority"
                            options={Priority_Options}
                            onChange={(e) => {
                                handleChange(e);
                            }}
                            showTooltip={true}
                            tooltipText={"Priority"}
                            isExpandedField={false}
                            isMandatory={false}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                        <TextArea
                            label="Problem Statement"
                            name="problem_statement"
                            isMandatory={true}
                            placeholder="Enter the issue you are facing..."
                            isExpandedField={true}
                            showTooltip={true}
                            tooltipText={"Problem Statement"}
                            textLimit={`${values?.problem_statement?.length}/1000 characters`}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                        <TextField
                            label="Home Network (PLMN)"
                            name="home_network"
                            type="text"
                            isMandatory={true}
                            placeholder="Enter here"
                            isExpandedField={false}
                            showTooltip={true}
                            tooltipText={"Home Network (PLMN)"}
                            textLimit={null}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                         <TextField
                            label="Visited Network (PLMN)"
                            name="visited_network"
                            type="text"
                            isMandatory={true}
                            placeholder="Enter here"
                            isExpandedField={false}
                            showTooltip={true}
                            tooltipText={"Visited Network (PLMN)"}
                            textLimit={null}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                        <TextField
                            label="Calling Global Titles (GT)"
                            name="calling_global_titles"
                            isMandatory={true}
                            type="text"
                            placeholder="Enter number"
                            isExpandedField={false}
                            showTooltip={true}
                            tooltipText={"Calling Global Titles (GT)"}
                            textLimit={null}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                        <TextField
                            label="Called Global Titles (GT)"
                            name="called_global_titles"
                            isMandatory={true}
                            type="text"
                            placeholder="Enter number"
                            isExpandedField={false}
                            showTooltip={true}
                            tooltipText={"Called Global Titles (GT)"}
                            textLimit={null}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                         <TextField
                            label="Originating Point Code (OPC) Details"
                            name="opc_detail"
                            isMandatory={false}
                            type="text"
                            placeholder="Enter number"
                            isExpandedField={false}
                            showTooltip={true}
                            tooltipText={"Originating Point Code (OPC) Details"}
                            textLimit={null}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                         <TextField
                            label="Destination Point Code (DPC) Details"
                            name="dpc_detail"
                            isMandatory={false}
                            type="text"
                            placeholder="Enter number"
                            isExpandedField={false}
                            showTooltip={true}
                            tooltipText={"Destination Point Code (DPC) Details"}
                            textLimit={null}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />                      
                        <TextField
                        label="Mobile Subscriber Identity (MSISDN)"
                        name="msi_MSISDN"
                        isMandatory={true}
                        type="text"
                        placeholder="Enter number"
                        isExpandedField={false}
                        showTooltip={true}
                        tooltipText={"Mobile Subscriber Identity (Destination)"}
                        textLimit={null}
                        isPreviewMode={props.isIncidentPreviewModeOn}
                       />      
                        <TextField
                            label="IMSI Details - A Party"
                            name="imsi_source"
                            isMandatory={true}
                            type="text"
                            placeholder="Enter here"
                            isExpandedField={false}
                            showTooltip={true}
                            tooltipText={"IMSI Details - A Party"}
                            textLimit={null}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                        <TextField
                            label="Error Received"
                            name="error_received"
                            isMandatory={false}
                            type="text"
                            placeholder="Enter here"
                            isExpandedField={false}
                            showTooltip={true}
                            tooltipText={"Error Received"}
                            textLimit={null}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                         <DateTimePicker
                            label="Date & Time of Issue Started (In GMT)"
                            name="date_time"
                            isMandatory={true}
                            placeholder={incidentTimePlaceHolder}
                            isExpandedField={false}
                            showTooltip={true}
                            tooltipText={"Date & Time of Issue Started (In GMT)"}
                            textLimit={null}
                            max={moment().format('YYYY-MM-DDTHH:mm')}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                            onCalendarOpen={handleCalendarOpen}
                            isUTCMode={true}
                            datePickerProps={{
                                showTimeSelect: true,
                                timeIntervals:incidentTimeInterval,
                                timeFormat: "HH:mm",
                                dateFormat: "dd/MM/yyyy HH:mm",
                                maxDate: dateLimits?.maxDate,
                                ...timeProps,
                                showMonthDropdown: true,
                                showYearDropdown: true,
                                popperPlacement: "bottom-start",
                            }}
                        />
                         <TextField
                            label="Source IP Details"
                            name="source_ip"
                            isMandatory={false}
                            type="text"
                            placeholder="Enter here"
                            isExpandedField={false}
                            showTooltip={true}
                            tooltipText={"Source IP Details"}
                            textLimit={null}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                         <TextField
                            label="Destination IP Details"
                            name="destination_ip"
                            isMandatory={false}
                            type="text"
                            placeholder="Enter here"
                            isExpandedField={false}
                            showTooltip={true}
                            tooltipText={"Destination IP Details"}
                            textLimit={null}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                        <TextField
                            label="Traces Routes"
                            name="traces_routes"
                            isMandatory={false}
                            type="text"
                            placeholder="Enter here"
                            isExpandedField={false}
                            showTooltip={true}
                            tooltipText={"Traces Routes"}
                            textLimit={null}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                        <div className={styles.expandedField}>
                         <MultipleEmailInput
                            name="additionalEmails"
                            label={FromLabel.additional_Email}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                            requestorEmail={props?.myRights?.email}
                            showTooltip={true}
                            isNote={true}
                            tooltipText={"Additional Emails"}
                        />  
                        </div>
                        <TextArea
                            label="Traces or Attachments"
                            name="trace_text"
                            isMandatory={true}
                            placeholder="Enter the issue you are facing..."
                            isExpandedField={true}
                            showTooltip={true}
                            tooltipText={"Traces or Attachments"}
                            textLimit={`${values?.trace_text?.length}/1000 characters`}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                        <ImageUpload
                            name="trace_file"
                            value={values.trace_file}
                            setFieldValue={setFieldValue}
                            isMandatory={true}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                            onFileDownload={onFileDownload}
                            actionType={actionType}
                        />
                         <TextArea
                            label="Additional Information"
                            name="additional_information"
                            isMandatory={false}
                            placeholder="Enter here"
                            isExpandedField={true}
                            showTooltip={true}
                            tooltipText={"Additional Information"}
                            textLimit={`${values?.additional_information?.length}/1000 characters`}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                    </Form>
                    {actionType===ADD_TICKET_ACTION.INCIDENT_DETAILS?
                         <footer className={`${styles.footer} ${actionType===ADD_TICKET_ACTION.INCIDENT_DETAILS ?styles.closedetalpopup:""}`}>
                            <EditButton
                            className={styles.backButton}
                            title={"Close"}
                            style={styles.btn}
                            onClick={()=>{
                                props.setIncidentPreviewMode(false);
                                props.closeForm();
                            }}/>
                         </footer>:
                    <footer className={styles.footer}>
                        {
                           props.isIncidentPreviewModeOn? 
                           <EditButton
                            className={styles.backButton}
                            title={"Edit"}
                            style={styles.btn}
                            onClick={()=>props.setIncidentPreviewMode(false)}
                        />:<EditButton
                            className={styles.backButton}
                            title={"Cancel"}
                            style={styles.btn}
                            onClick={()=>{
                                props.setIncidentPreviewMode(false);
                                props.closeForm();
                            }}
                        />
                        }
                        <Submit
                            id="saveButton"
                            title={props.isIncidentPreviewModeOn?"Submit":"Preview"}
                            form="diameter_signalling_issue_form"
                            style={styles.btn}
                            isSubmitting={isSubmit}
                            disabled={!isValid || !dirty}
                        />
                    </footer>
                   }
                </>
            )}}

        </Formik>
    )

}

const mapStateToProps = (state)=>{   
    return {
        isIncidentPreviewModeOn:state.IncidentManagement.isIncidentPreviewModeOn,
        myRights:state.myRights.myRights,
        incidentActiveTab:state.incidentTab.incidentActiveTab,     
    }
  }

const mapDispatchToProps = (dispatch)=>{
    return {
        setIncidentPreviewMode: (payload) => {
            return dispatch(setIncidentPreviewMode(payload))
        },
        addIncident: (payload) => { console.log("payload",payload);
        
            return dispatch(SubmitIncident(payload))
        },
        openAlertPopup: (payload) => {
            return dispatch(openAlertPopup(payload))
        },
        getIncidentList: (next=null)=>{
            return dispatch(getIncidentList(next))
        },
        incidentDownloadFile:(originalFileName,uniqueFileName,messageId,attachmentId,graphInternetMessageId)=>{
            return dispatch(incidentDownloadFiles(originalFileName,uniqueFileName,messageId,attachmentId,graphInternetMessageId))
        },
        setIncidentActiveTab: (tab) => {
            return dispatch(setIncidentActiveTab(tab))
        },
        showErrorPopup: (errorHeader,errormessage,isnote) => {
            return dispatch(showErrorPopup(errorHeader,errormessage,isnote))
        },
        getModuleNotification: () => {
             return dispatch(getModuleNotification())
        },
    }
  };
  
export default connect(mapStateToProps, mapDispatchToProps)(SigtranSignallingIssueMultipleForm);

